import React, { Component } from 'react';
import './DeepARLegend.css';
import { t } from 'i18next';

class DeepARLegend extends Component {
  render() {
    return (
      <div className="deepAR graph-row-legend">
        <div className="legend">
          <div className="line"
            style={{
              backgroundColor: '#DC3552',
            }}
          />
          <div className="text">
            {t('tensorAnalytics.deepARGraphs.forecasted')}
          </div>
        </div>
        <div className="legend">
          <div className="box"
            style={{
              backgroundColor: '#E7E3FF',
            }}
          />
          <div className="text">
            {t('tensorAnalytics.deepARGraphs.confidence')}
          </div>
        </div>
        <div className="legend">
          <div className="line split" />
          <div className="text">
            {t('tensorAnalytics.deepARGraphs.split')}
          </div>
        </div>
      </div>
    );
  }
}

export default DeepARLegend;
